import { ServiceMaker, methods, services } from "@/services";

export const partnerWalletStatement = payload =>
  ServiceMaker(
    `/wallet/wallet/history?from=${payload.from}&to=${payload.to}`,
    methods.POST,
    services.master,
    payload.data
  );

export const partnerWalletStatementAll = payload =>
  ServiceMaker(
    `/wallet/wallet/history`,
    methods.POST,
    services.master,
    payload
  );

// partner my own //

export const partnerMyOwnWalletStatement = payload =>
  ServiceMaker(
    `/wallet/wallet/history?from=${payload.from}&to=${payload.to}`,
    methods.GET,
    services.master
  );
  
export const partnerMyOwnWalletStatementAll = () =>
  ServiceMaker(`/wallet/wallet/history`, methods.GET, services.master);
